"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SavingsAndPromosState = /** @class */ (function () {
    function SavingsAndPromosState() {
    }
    return SavingsAndPromosState;
}());
exports.default = SavingsAndPromosState;
//# sourceMappingURL=SavingsAndPromosState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/SavingsAndPromos/SavingsAndPromosState.js
// module id = 2313
// module chunks = 8